import { render, staticRenderFns } from "./Subir_Archivo.vue?vue&type=template&id=6c8cdffb&"
import script from "./Subir_Archivo.vue?vue&type=script&lang=js&"
export * from "./Subir_Archivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports